module.exports = __webpack_public_path__ + "static/media/book-forward.7cbd56af.png";